/**
 * @fileoverview
 * Define la estructura del menú lateral de navegación de la aplicación.
 * Cada entrada contiene la ruta (`path`), ícono (`icon`) y título (`title`).
 * Algunas entradas pueden tener submenús definidos en `children`.
 *
 * @type {Array<Object>}
 */

const Menu = [
	/**
	 * Dashboard principal
	 */
	{ 
		path: '/dashboard', 
		icon: 'bi bi-cpu', 
		title: 'Dashboard' 
	},

	/**
	 * Sección de administración (usuarios, candidatos, colegios)
	 */
	{ 
		path: '/admin', 
		icon: 'bi bi-people-fill', 
		title: 'Administración',
		children: [
			{ path: '/admin/users', title: 'Usuarios' },
			{ path: '/admin/candidates', title: 'Candidatos' },
			{ path: '/admin/colleges', title: 'Colegios' }
		]
	},

	/**
	 * Sección de preguntas para certificaciones
	 */
	{ 
		path: '/admin', 
		icon: 'bi bi-question-lg', 
		title: 'Preguntas',
		children: [
			{ path: '/admin/questions/epst', title: 'EPSt' },
			{ path: '/admin/questions/emet', title: 'EMeT' }
		]
	},

	/**
	 * Sección de resultados accesible por los examinadores
	 */
	{ 
		path: '/examiner', 
		icon: 'bi bi-question-lg', 
		title: 'Resultados',
		children: [
			{ path: '/examiner/results/epst', title: 'EPSt' },
			{ path: '/examiner/results/emet', title: 'EMeT' }
		]
	}
];

export default Menu;